import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  closeDrawerButtonAriaLabel: {
    defaultMessage: 'Close Subscription Selection Drawer',
    description: 'Label for button that closes subscription drawer',
    id: 'OxLR/c',
  },
  drawerHeaderText: {
    defaultMessage: 'Edit Subscription Plan',
    description: 'Title of the new subscription drawer that tells the user what the drawer is showcasing.',
    id: 'ReVG+t',
  },
  subscriptionDrawerConfirmExitHeader: {
    description: 'Header text to exit ShipStation Subscription Plan Change before saving their selection',
    defaultMessage: 'Exit Subscription Plan Change',
    id: 'yMW6XO',
  },
  subscriptionDrawerConfirmExitBody: {
    description: 'Body text to exit ShipStation Subscription Plan Change',
    defaultMessage: 'Are you sure you want to exit before saving changes to your subscription plan?',
    id: 'NZ1BuF',
  },
  subscriptionDrawerConfirmExitButton: {
    description: 'Button text to exit ShipStation Subscription Plan Change',
    defaultMessage: 'Exit',
    id: 'Hov7N+',
  },
  included: {
    defaultMessage: 'Included',
    description: 'label to indicate when a feature is included',
    id: 'eG4tEk',
  },
  trialExpiredBannerHeader: {
    defaultMessage: 'Your trial has expired and you have been downgraded to the Free plan',
    description: 'Message shown when user first logs in after trial expires and is on free plan',
    id: 'k/7AKh',
  },
  trialExpiredBannerSubheader: {
    defaultMessage: 'Access to additional stores and users is limited on your current plan. Upgrade to restore full access.',
    description: 'Message shown when user first logs in after trial expires and is on free plan',
    id: 'MY57bO',
  },
  upgradePromotionHeader: {
    defaultMessage: 'Upgrade your plan to unlock new features',
    description: 'Header text for promotional banner encouraging plan upgrades',
    id: 'eX1gxn',
  },
  upgradePromotionSubheader: {
    defaultMessage: 'Based on your interest, we suggest upgrading to the plan below.',
    description: 'Subheader text for promotional banner with upgrade suggestion',
    id: 'Azudh5',
  },
});
